// English-only UI copy for an unlisted, gated neonatal editorial review.
// These draft values must enter the formal clinical and translation sources before release.
export const NEONATAL_PREVIEW_UI_COPY = Object.freeze({
  "furtherReading": "Further reading",
  "sourceDisclaimer": "Links open on the provider’s website. Know Your Care has drafted its own summary; these organisations have not approved or endorsed it.",
  "back": "Back to Journeys",
  "warning": "Unapproved neonatal editorial preview · Not for patient use",
  "eyebrow": "Know Your Care · Parent and carer journey",
  "intro": "A guide for families with a baby in a Special Care Baby Unit (SCBU), high-dependency care or a Neonatal Intensive Care Unit (NICU).",
  "orientation": "Your baby’s care will be individual, and progress is not always predictable. There is no need to read everything or follow these sections in order.\n          Choose what helps you understand your baby’s care and what you want to ask the team.",
  "explore": "Explore the journey",
  "words": "Words you might hear",
  "support": "Support for your family",
  "returnAny": "Return to any section whenever you wish",
  "glossaryDisclaimer": "These are general explanations, not a description of your baby’s treatment.",
  "optionalResources": "Optional resources",
  "practicalSupport": "Looking after a baby in neonatal care can be demanding. You can ask the unit about emotional support, peer support, interpreting, accessibility needs, parking, meals, accommodation, transport and help for siblings.",
  "neonatalLeave": "Eligible working parents may be entitled to Neonatal Care Leave and Pay. Check the up-to-date criteria with your employer and the published guidance rather than assuming that every family qualifies.",
  "sensitiveSupport": "If you are facing serious illness, difficult decisions or bereavement, you can ask for private, specialist support. Reading about these topics is optional.",
  "quickOverview": "A quick overview",
  "exploreSection": "Explore this section",
  "topicSources": "Source-informed draft; see the original organisations’ links below for further reading.",
  "people": "People you might meet",
  "rolesCaveat": "Job titles and responsibilities vary between hospitals.",
  "questions": "Questions you could ask",
  "questionsCaveat": "Tick any questions you want to remember during this review. Selections are not saved or shared.",
  "previous": "Previous section",
  "next": "Next section",
  "safetyNetting": "This is not a medical advice service. For concerns while your baby is in hospital, speak to the neonatal team. After discharge, use the contact details and safety advice provided in your baby’s plan. For life-threatening emergencies, call 999.",
  "navLabel": "Neonatal journey sections",
  "sourceLabel": "Further reading",
  "opensNewTab": " (opens in new tab)",
  "rolesLabel": "People involved in this section",
  "questionsLabel": "Questions to ask your neonatal team",
  "section": "Section",
  "of": "of",
  "anyOrder": "· Browse in any order",
  "nonLinearHint": "These are topics, not milestones. Choose any section.",
  "neonatalUnitLabel": "Neonatal care · SCBU, HDU and NICU",
  "hospitalJourney": "Hospital Journey",
  "reassuranceTitle": "Here for you, one question at a time",
  "reassuranceBody": "You do not need to read everything. Start with what feels most useful today, and ask your baby's neonatal team about your baby's individual care.",
  "localInfoTitle": "Information from your hospital",
  "localInfoDescription": "Trust-specific guidance can be added here after local review. These entries are not active links.",
  "localPlaceholder": "Awaiting local Trust information and approval",
  "stageNavigationLabel": "Neonatal journey section navigation",
  "machineNotice": "Machine-translated draft: language and clinical review are still needed. This is not guidance for your baby's individual care.",
  "languageSelectorLabel": "Preview language"
});
